import React from 'react';

import Page from 'marketing-website/components/modules/Page';
import assets from 'marketing-website/configs/pages/financial-services/assets';
import logos from 'marketing-website/configs/pages/financial-services/logos';
import Security from 'marketing-website/components/modules/SecuritySection';
import ImageBlock from 'marketing-website/components/modules/ImageBlock';
import Logos from 'marketing-website/components/modules/Logos';
import IndustryHeader from 'marketing-website/components/modules/IndustryHeader';
import CTA from 'marketing-website/components/modules/Cta/CtaDemo';
import MonzoUpsell from 'marketing-website/components/modules/MonzoUpsell';

import { requestDemoFinanceId } from 'marketing-website/configs/hubspot';
import metaData from 'marketing-website/data/metadata.js';

const facebookMeta = [
  {
    name: 'og:title',
    content: 'Marvel for Finance - Create better customer experiences',
  },
  {
    name: 'og:site_name',
    content: 'Marvel for Finance',
  },
  {
    name: 'og:type',
    content: 'website',
  },
  {
    name: 'og:url',
    content: 'https://marvelapp.com/financial-services',
  },
  {
    name: 'og:description',
    content:
      "Explore how Marvel's collaborative design platform can help your financial business create a better customer experience and drive digital transformation.",
  },
  {
    name: 'og:image',
    content: `https://marvelapp.com${assets.sharePreview.src}`,
  },
  {
    name: 'og:site_name',
    content: 'Marvel for Finance',
  },
];

const twitterMeta = [
  {
    name: 'twitter:site',
    content: 'https://marvelapp.com/financial-services',
  },
  {
    name: 'twitter:creator',
    content: '@marvelapp',
  },
  {
    name: 'twitter:title',
    content: 'Marvel for Finance - Create better customer experiences',
  },
  {
    name: 'twitter:image',
    content: `https://marvelapp.com${assets.sharePreview.src}`,
  },
];

const meta = {
  title: metaData['financial-services'].title,
  meta: [
    {
      name: 'description',
      content: metaData['financial-services'].description,
    },
    ...twitterMeta,
    ...facebookMeta,
  ],
  header: { isLight: false },
  footer: true,
};

export default function FinancialServices() {
  const ctaLink = `/enterprise/request-demo?hformid=${requestDemoFinanceId}`;

  return (
    <Page {...meta}>
      <IndustryHeader
        label="Marvel for Financial Services"
        imageAsset={assets.hero}
        title="Disrupt and deliver with innovative Design Thinking"
        paragraph="Marvel makes it easy to introduce and implement new user-centric
            methodologies and workflows that transform your customer's digital
            experience. Design is at the centre of innovation and our tools can
            help you open up the design processes to your entire business,
            increase your time to market and connect you with your audience,
            fast."
        ctaLink={ctaLink}
      />
      <Logos
        title={
          <span>
            Join these leading financial companies who use{' '}
            <span style={{ fontWeight: 'bold' }}>Marvel Enterprise</span> to
            scale design
          </span>
        }
        logos={logos}
      />

      <ImageBlock
        paragraphSize="m"
        title="Ideate, create and ship user-centric solutions"
        copy={
          <span>
            Research has found that when human-centered design sits at the core
            of a growth strategy, it brings a 228% higher ROI. With built-in
            User Testing, Marvel enables you to reach your customers, wherever
            they are in the world, through sharing a single URL.
            <br />
            <br />
            Collate video, audio and analytical feedback for your prototypes in
            a single space. No hardware or lab space required!
          </span>
        }
        headingMaxWidth={390}
        paragraphMaxWidth={480}
        imageAsset={assets.ideate}
        ctaLink={ctaLink}
      />

      <ImageBlock
        paragraphSize="m"
        title="Validate fast and reduce your time to market"
        copy={
          <span>
            Consolidate your tools with Marvel and experience a collaborative
            space to create and share design work, fast. Our customers see
            feedback loops closed to minutes using features like commenting,
            annotating and visibility dashboards.
            <br />
            <br />
            Our platform is built to scale with integrations like Sketch,
            Microsoft Teams and JIRA which boost productivity and automate your
            design process.
          </span>
        }
        headingMaxWidth={435}
        paragraphMaxWidth={435}
        imageAsset={assets.validate}
        isRightAligned
        ctaLink={ctaLink}
      />

      <ImageBlock
        paragraphSize="m"
        title="Democratise design and drive digital transformation"
        copy={
          <span>
            From designers to researchers and analysts, Marvel consolidates and
            simplifies dozens of professional, creative workflow tools -
            enabling every department to wireframe, design and prototype.
            <br />
            <br />
            We strive to lower the entry barrier for design and creative
            tooling. That's why it takes less than 30 minutes to onboard and
            complete your first project with Marvel. With no learning curve, our
            platform empowers every team to drive a design-led culture.
          </span>
        }
        headingMaxWidth={458}
        paragraphMaxWidth={458}
        imageAsset={assets.democratise}
        ctaLink={ctaLink}
      />

      <Security />
      <MonzoUpsell />
      <CTA
        heading="Challenge the industry norm and become a CX centric design leader with Marvel Enterprise."
        ctaLink={ctaLink}
      />
    </Page>
  );
}



// WEBPACK FOOTER //
// ./src/pages/financial-services/index.js